@if (isLoading) {
  <div>
    <div class="loader__container">
      <h2>Loading</h2>
      <div class="loader"></div>
    </div>
  </div>
}

@if (!isLoading) {
  <div class="full-container">
    @if (isReviewQueueItemLocked) {
      <app-locked-takeover
        [lastLockedBy]="reviewQueueItem.lastLockedBy"
      ></app-locked-takeover>
    }
    <app-digitization-top-nav
      [document]="reviewQueueItem"
      (saveMethod)="save()"
      (nextMethod)="next()"
      >
      <div class="toggler">
        <span>View All Pages</span>
        @if (!areAllPagesShown) {
          <i class="fas fa-toggle-off" (click)="togglePagesShown()"></i>
        }
        @if (areAllPagesShown) {
          <i class="fas fa-toggle-on" (click)="togglePagesShown()"></i>
        }
      </div>
      <div>
        <div class="d-flex flex-row align-items-center flex-wrap">
          <label class="currency d-flex align-items-center">Set Currency </label>
          <select class="form-select w-auto" (change)="changeCurrency($event.target.value)">
            @for (currency of supportedCurrencies; track currency) {
              <option [value]="currency.key"
                [selected]="currency.key === this.documentFile.currency">
                {{currency.key}} ({{currency.symbol}})
              </option>
            }
          </select>
        </div>
      </div>
    </app-digitization-top-nav>
    <div class="main-wrapper" #wrapper>
      @if (_sharedDataService.shouldShowManualReviewSidebar) {
        <app-maximized-sidebar
          [stepHeader]="stepHeader"
          [tipsBody]="tipsBody"
          [steps]="steps"
          [fullGif]="fullGif"
          [title]="'Column Adjustments'"
          (toggleSidebar)="toggleStepsToSuccess()">
        </app-maximized-sidebar>
      }
      @if (!_sharedDataService.shouldShowManualReviewSidebar) {
      }
      <div class="thumbnail-sidebar">
        <ul class="page-thumbnails" appImgIntersectionObxList>
          <label class="select-page-label page-label">Select page</label>
          @for (page of pagesToShow; track page; let i = $index) {
            <li
              appImgIntersectionObx
              #intersection="intersection"
              [id]="'thumbnail-' + i"
              #thumbnailItem>
              @if (intersection.hasIntersected) {
                <app-box-drawer
                  [sidebar]="_sharedDataService.shouldShowManualReviewSidebar"
                  [allowEdit]="false"
                  [inputImageWidth]="300"
                  [boxes]="boxesByPage?.[page.pageIndex]"
                  [showActiveBorder]="page.pageIndex == activePageIndex"
                  (boxClicked)="boxClicked($event, page.pageIndex)"
                  [sourceImageUrl]="page.thumbnail.signedUrl"
                ></app-box-drawer>
              } @else {
                <div class="image-placeholder">
                  ...
                </div>
              }
            </li>
          }
        </ul>
      </div>
      @if (pagesWithBoxesDrawn.length > 0) {
        <div id="review-table-tabulation-container">
          <label class = "adjust-columns-label page-label">Adjust columns</label>
          @if (tablesByPage?.[activePageIndex]?.[activeTableIndex]) {
            <app-box-drawer
              [sidebar]="_sharedDataService.shouldShowManualReviewSidebar"
              [allowEdit]="true"
              [inputImageWidth]="600"
              [boxes]="tablesByPage[activePageIndex][activeTableIndex].columnStructure"
              [sourceImageUrl]="documentFile.pageImages[activePageIndex].normalRes.signedUrl"
              scrollingContainerElementId="review-table-tabulation-container"
            ></app-box-drawer>
          }
        </div>
        <div class="tabulation-output col-3 flex-shrink-1">
          <label class = "selected-data-label page-label">Selected data</label>
          @if (tablesByPage?.[activePageIndex]?.[activeTableIndex]) {
            <table class="tabulation">
              <tbody>
                @for (row of tablesByPage[activePageIndex][activeTableIndex].cells; track row) {
                  <tr>
                    @for (cell of row; track cell) {
                      <td class="ellipses"
                            [ngClass]="{
                    'fs-exclude': cell.columnNumber == 0,
                    'fs-block': cell.columnNumber == 0
                }"
                        title="{{row.label}}"
                      >{{cell.rawText}}</td>
                    }
                  </tr>
                }
              </tbody>
            </table>
          }
        </div>
      } @else {
        <div class="error-state-container">
          <app-table-empty-state
            emptyStateIcon="fa-file-circle-question"
            headerText="No tables found"
            [helpText]="noTablesFoundHelpText"
          ></app-table-empty-state>
        </div>
      }
    </div>
  </div>
}
